// extracted by mini-css-extract-plugin
export default {"link":"Link_link__j3yA7","linkNoLine":"Link_linkNoLine__DzVfB"};